import AdminLayout from '../components/AdminLayout';
import AdminProductsContent from './ProductsContent';

export default function AdminProductsPage() {
  return (
    <AdminLayout title="Products">
      <AdminProductsContent />
    </AdminLayout>
  );
}
